import { RouteConfig } from '../../../../routing/types'

export type PathArgs = any[]

const ROUTE: RouteConfig<PathArgs> = {
  name: 'membership-payment-update',
  path: () => '/membership/payment',
  type: 'private',
}

export default ROUTE
